import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { userActions } from '../../../actions/user.actions';
import 'moment-timezone';
import moment from 'moment';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import TextField from '@mui/material/TextField';
import './index.css';
import close from "../../../assets/images/close.png";
import Datetime from 'react-datetime';
import Grid from '@mui/material/Grid';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

const style = {
   
   
  justifyContent: 'center',
  width: 600,
  bgcolor: 'background.paper',
  height:'auto',
  overflowY: 'scroll',
  boxShadow: 20,
  borderRadius:2,
  marginTop:'2em',
  marginBottom:'2em'
   
  
};



export default function ManualPayment({ totalEmiAmount, selectedItems, chequeBounceCharges, loanDetails, overdueCharges, interest, userId, remainingAmount, legalCharges, isPreClosure, discountedBounce, discountedPenalty, principleAmount, paidBounce, paidPenalty, paidPrinciple, paidInterest, principle, loanstate,
  activityNotes,
  setActivityNotes,
  remarksError,
  setRemarksError }) {
  const [open, setOpen] = React.useState(false);
  const user = null;
  const { loanid, legacyLoanId } = useSelector(state => state.appContext);const handleOpenDialog=()=>{
      setOpen(true)
      setEmiReceivedAmount("");
      setReceivedBounceCharges("");
      setReceivedPenalty("");
      setReceivedLegalCharges("");
      setEmiAmountDiscount("");
      setBounceChargesDiscount("");
      setPenaltyDiscount("");
      setLegalChargesDiscount("");
      setAdjustmentAmount(null);
      setTransactionId(null);
      setSelectedDate(null);
      setReasonCode("Select");
      setBank("Select")
      setValueRadio('A/C Transfer');
      const initialEmiAmount =
  principle + interest - (paidPrinciple + paidInterest) - emiAmountDiscount;
  setEmiReceivedAmount(isPreClosure ? totalEmiAmount : initialEmiAmount);
     
  }
    const dispatch=useDispatch();
const [valueRadio, setValueRadio] = React.useState('A/C Transfer');

  const handleChange = (event) => {
    setValueRadio(event.target.value);
  };

const [maxDiscount,setMaxDiscount]=useState(0)
useEffect(() => {
  const discount = Math.round((principleAmount * 2) / 100);
  setMaxDiscount(discount)
}, [principleAmount]);
 
const [transactionId,setTransactionId]=React.useState(null)
const [receivedEmiAmount,setEmiReceivedAmount]=React.useState("")
const [receivedBounceCharges,setReceivedBounceCharges]=React.useState("")
const [receivedPenalty,setReceivedPenalty]=React.useState("")
const [receivedLegalCharges,setReceivedLegalCharges]=React.useState("")
const [emiAmountDiscount,setEmiAmountDiscount]=React.useState("")
const [bounceChargesDiscount,setBounceChargesDiscount]=React.useState("")
const [penaltyDiscount,setPenaltyDiscount]=React.useState("")
const [legalChargesDiscount,setLegalChargesDiscount]=React.useState("")
const [adjustmentAmount,setAdjustmentAmount]=React.useState(null)
const [selectedDate,setSelectedDate]=React.useState(null)
const [reasonCode,setReasonCode]=React.useState("Select")
const [bank,setBank]=React.useState("Select")
const [preclosureDiscount, setPreclosureDiscount] = React.useState("");

const handleEmiAmount=(event)=>{
  setEmiReceivedAmount(event.target.value);
}

    const formattedDate = selectedDate?.toLocaleString('en-US', {
      month: 'short',
      day: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    });
var date = new Date(formattedDate);

const generateReceipt=()=>{
  const urlGenerateReceipt='/loan-repayment/manual-repayment'
  
  if (emiAmountDiscount > maxDiscount) {
    alert(`Emi Discount should not be more than ${maxDiscount}`);
    return;
  }
  
  if (bounceChargesDiscount > maxBounceDiscount || bounceChargesDiscount < 0) {
    alert(`Bounce charges discount must be between 0 and ${maxBounceDiscount.toFixed(2)}`);
    return;
  }
  
  if (penaltyDiscount > maxPenaltyDiscount || penaltyDiscount < 0) {
    alert(`Penalty discount must be between 0 and ${maxPenaltyDiscount.toFixed(2)}`);
    return;
  }
  if (
    (Number(reasonCode) === 5 || (Number(loanstate?.status) === 4 && Number(reasonCode) === 4)) &&
     (!activityNotes || activityNotes.trim().length < 50)
    ) 
    {
    setRemarksError(true);
    alert('Please enter notes with minimum 50 characters');
    return;
  }
    const body={
      userId:userId,
      loanId: loanid,
      legacyLoanId: legacyLoanId,
      emiIds:selectedItems,
      transactionId: transactionId?.trim(),
      // transactionProofUrl: proof,
      repaymentId: "string",
      paymentAmount:Number(receivedEmiAmount),
      // paymentAmount:receivedEmiAmount?(Number(receivedEmiAmount)(chequeBounceCharges-discountedBounce-bounceChargesDiscount-paidBounce) + (overdueCharges-discountedPenalty-penaltyDiscount-paidPenalty)):(Number(Number((principle+interest-(paidPrinciple-paidInterest)))-Number(emiAmountDiscount)) + (chequeBounceCharges-discountedBounce-bounceChargesDiscount-paidBounce) + (overdueCharges-discountedPenalty-penaltyDiscount-paidPenalty)),
      paymentMode: valueRadio==="A/C Transfer"?3:valueRadio==="UPI"?2:1,
      paidAt: date ,
      manualPaymentReason:Number(reasonCode),
      bank:Number(bank),
      notes: activityNotes?.trim(),
      bounceDiscount: Number(bounceChargesDiscount),
      penaltyDiscount: Number(penaltyDiscount),
      preclosureDiscount: Number(preclosureDiscount?preclosureDiscount:0)
    }
    dispatch(userActions.generateManualPaymentReceipt(urlGenerateReceipt,user,body))
  
}
  const [bounceDiscountError, setBounceDiscountError] = useState('');
  const [penaltyDiscountError, setPenaltyDiscountError] = useState('');

  const maxBounceDiscount = chequeBounceCharges - discountedBounce - paidBounce;
  const maxPenaltyDiscount = overdueCharges - discountedPenalty - paidPenalty;
  const handleBounceDiscountChange = (event) => {
  const value = event.target.value;
  setBounceChargesDiscount(value);

  const numericValue = parseFloat(value) || 0;

  if (numericValue > maxBounceDiscount) {
    setBounceDiscountError(`Max discount is ${maxBounceDiscount.toFixed(2)}`);
  } else if (numericValue < 0) {
    setBounceDiscountError('Discount cannot be negative');
  } else {
    setBounceDiscountError('');
  }
};

  const handlePenaltyDiscountChange = (event) => {
  const value = event.target.value;
  setPenaltyDiscount(value);

  const numericValue = parseFloat(value) || 0;

  if (numericValue > maxPenaltyDiscount) {
    setPenaltyDiscountError(`Max discount is ${maxPenaltyDiscount.toFixed(2)}`);
  } else if (numericValue < 0) {
    setPenaltyDiscountError('Discount cannot be negative');
  } else {
    setPenaltyDiscountError('');
  }
};

const calculateReceivedAmount = (totalAmount, discountedAmount, currentDiscount, paidAmount, maxDiscount) => {
  const numericDiscount = parseFloat(currentDiscount) || 0;
  
  if (numericDiscount > maxDiscount || numericDiscount < 0) {
    return totalAmount - discountedAmount - paidAmount;
  }
  
  return totalAmount - discountedAmount - numericDiscount - paidAmount;
};
    
const isFormInvalid = !!bounceDiscountError || !!penaltyDiscountError;
const isSpanClickable = selectedItems.length>=1 || isPreClosure;
  return (
    <>
    <p  style={{  fontSize: '14px',color:'#314158', lineHeight:1, fontWeight:'bold' }} onClick={isSpanClickable?() => handleOpenDialog():null} >
     Create Manual Payment
    </p>
      <Modal
        open={open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        style={{display:'flex',justifyContent:'center'}}
      >
        <Box sx={style}>
          <Typography style={{borderTopLeftRadius:'8px',borderTopRightRadius:'8px',backgroundColor:'#F0F0F0' ,borderBottom:'1px solid #D0D0D0',display:'flex',justifyContent:'space-between',paddingLeft:'2%',paddingRight:'2%'}}      >
           <p style={{fontSize:'20px',paddingTop:'10px',fontWeight:'bold'}}> Manual Payment Update </p>
            <img src={close} style={{cursor:'pointer',height:'1.5rem',marginTop:'1em'}} alt="" onClick={() => {setOpen(!open);window.location.reload()}}/>
          
          </Typography>
          <Grid container spacing={2} paddingLeft="10px" paddingRight="10px" marginTop="10px">
          <Grid item xs={4}>
          <TextField label="Total Remaining Emi Amount" variant="outlined" InputLabelProps={{style: { fontSize: '12px' },shrink: true}} value={(principle+interest-(paidPrinciple-paidInterest))} disabled/>
          </Grid>
          <Grid item xs={4}>
          <TextField label="Amount Received"  variant="outlined" type='number'  InputLabelProps={{style: { fontSize: '12px' }}} value={receivedEmiAmount} onChange={handleEmiAmount}/>
          </Grid>
          <Grid item xs={4}>
          <TextField label="Emi Amount Discount"  variant="outlined"  InputLabelProps={{style: { fontSize: '12px' }}} value={emiAmountDiscount} onChange={(event)=>{setEmiAmountDiscount(event.target.value)}}  disabled={!isPreClosure}/>
          </Grid>
          </Grid>
          <Grid container spacing={2} paddingLeft="10px" paddingRight="10px" marginTop="10px">
          <Grid item xs={4}>
          <TextField label="Total Bounce Charges" variant="outlined" InputLabelProps={{style: { fontSize: '12px' },shrink: true}} value={(chequeBounceCharges-discountedBounce-paidBounce)} disabled/>
          </Grid>
          <Grid item xs={4}>
          <TextField 
            label="Bounce Chrgs Recvd" 
            variant="outlined"  
            InputLabelProps={{style: { fontSize: '12px' }}} 
            value={calculateReceivedAmount(chequeBounceCharges, discountedBounce, bounceChargesDiscount, paidBounce, maxBounceDiscount)} 
            onChange={(event)=>{setReceivedBounceCharges(event.target.value)}}
          />         
          </Grid>
          <Grid item xs={4}>
          <TextField label="Bounce Chrgs Discnt" variant="outlined" InputLabelProps={{style: { fontSize: '12px' }}} value={bounceChargesDiscount} onChange={handleBounceDiscountChange} error={!!bounceDiscountError} helperText={bounceDiscountError}/>
          </Grid>
          </Grid>
          <Grid container spacing={2} paddingLeft="10px" paddingRight="10px" marginTop="10px">
          <Grid item xs={4}>
          <TextField label="Total Penlty" variant="outlined" InputLabelProps={{style: { fontSize: '12px' },shrink: true}} value={(overdueCharges-discountedPenalty-paidPenalty)} disabled/>
          </Grid>
          <Grid item xs={4}>
          <TextField 
            label="Penlty Received" 
            variant="outlined" 
            InputLabelProps={{style: { fontSize: '12px' }}} 
            value={calculateReceivedAmount(overdueCharges, discountedPenalty, penaltyDiscount, paidPenalty, maxPenaltyDiscount)} 
            onChange={(event)=>{setReceivedPenalty(event.target.value)}}
          />          
          </Grid>
          <Grid item xs={4}>
          <TextField label="Penlty Discount" variant="outlined" InputLabelProps={{style: { fontSize: '12px' }}} value={penaltyDiscount}  onChange={handlePenaltyDiscountChange} error={!!penaltyDiscountError} helperText={penaltyDiscountError}/>
          </Grid>
          </Grid>
          {/* <p style={{fontFamily:'Inter-Medium',fontSize:'14px',marginBottom:'-3px',paddingLeft:'10px',fontWeight:'600',paddingTop:'10px' }}>Legal Charges: </p> */}
          <Grid container spacing={2} paddingLeft="10px" paddingRight="10px" marginTop="10px">
          <Grid item xs={4}>
          <TextField label="Legal Charges" variant="outlined" InputLabelProps={{style: { fontSize: '12px'},shrink: true}} value={legalCharges} disabled/>
          </Grid>
          <Grid item xs={4}>
          <TextField label="Legal Chrgs Received" variant="outlined" InputLabelProps={{style: { fontSize: '12px'}}} value={receivedLegalCharges} onChange={(event)=>{setReceivedLegalCharges(event.target.value)}}/>
          </Grid>
          <Grid item xs={4}>
          <TextField label="Legal Chrgs Discount" variant="outlined" InputLabelProps={{style: { fontSize: '12px'}}} value={legalChargesDiscount} onChange={(event)=>{setLegalChargesDiscount(event.target.value)}}/>
          </Grid>
          </Grid>
           {(isPreClosure &&(loanDetails?.facilityType !== 1 && loanDetails?.facilityType !== 5))&& (
            <Grid container spacing={2} paddingLeft="10px" paddingRight="10px" marginTop="10px">
              <Grid item xs={4}>
                  <TextField 
                      label="Preclosure Charges" 
                      variant="outlined"  
                      InputLabelProps={{style: { fontSize: '12px' }}} 
                      value={(principle+interest-(paidPrinciple-paidInterest))*((loanDetails?.preCloseCharges)/100)} 
                      disabled
                  />
              </Grid>
              <Grid item xs={4}>
                  <TextField 
                      label="Preclosure Discount" 
                      variant="outlined"  
                      InputLabelProps={{style: { fontSize: '12px' }}} 
                      value={preclosureDiscount} 
                      onChange={(event)=>{setPreclosureDiscount(event.target.value)}}
                  />
              </Grid>
              
            </Grid>
          )}
          <p style={{fontFamily:'Inter-Medium',fontSize:'14px',marginBottom:'-3px',paddingLeft:'10px',fontWeight:'500',paddingTop:'10px' }}>Mode Of Payment: </p>
          <div style={{display:'block',marginBottom:'0.5em',paddingLeft:'10px',paddingRight:'10px'}}>
          <RadioGroup  
          style={{display:'flex',flexDirection: 'row',justifyContent: 'space-between',}}
              aria-labelledby="demo-controlled-radio-buttons-group"
              name="controlled-radio-buttons-group"
              value={valueRadio}
              onChange={handleChange}
            >
              <FormControlLabel value="A/C Transfer" control={<Radio />} label={<span style={{ fontFamily: 'Inter-Medium', fontSize: '14px',color:'gray' }}>A/C Transfer</span>} />
              <FormControlLabel value="Cheque" control={<Radio />} label= {<span style={{ fontFamily: 'Inter-Medium', fontSize: '14px' ,color:'gray'}}>Cheque</span>}/>
              <FormControlLabel value="UPI" control={<Radio />} label= {<span style={{ fontFamily: 'Inter-Medium', fontSize: '14px' ,color:'gray'}}>UPI</span>} />
           </RadioGroup>
           
          </div>
          <Grid container spacing={2} paddingLeft="10px" paddingRight="10px">
          <Grid item xs={6}>
          <Typography gutterBottom style={{fontFamily:'Inter-Medium',fontSize:'14px',marginBottom:'-3px',fontWeight:'500' }}>Select Category</Typography>

          <Box sx={{ minWidth: 120 }}>
          <FormControl fullWidth>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select" onChange={(e)=>setReasonCode(e.target.value)} value={reasonCode} style={{border:'none',fontSize:'14px',color:'gray'}}
            >
              <MenuItem value="Select">Select</MenuItem>
              <MenuItem value={1}>Preclosure</MenuItem>
              <MenuItem value={2}>Overdue</MenuItem>
              <MenuItem value={3}>Single EMI payment</MenuItem>
              <MenuItem value={4}>Multiple EMIs</MenuItem>
              <MenuItem value={5}>Settlement</MenuItem>
              <MenuItem value={6}>Refund By Institute</MenuItem>
            </Select>
          </FormControl>
        </Box>          
          </Grid>
          <Grid item xs={6}>
          <Typography gutterBottom style={{fontFamily:'Inter-Medium',fontSize:'14px',marginBottom:'-3px',fontWeight:'500' }}>Select Bank</Typography>

          <Box sx={{ minWidth: 120 }}>
          <FormControl fullWidth>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select" onChange={(e)=>setBank(e.target.value)} value={bank} style={{border:'none',fontSize:'14px',color:'gray'}}
            >
              <MenuItem value="Select">Select</MenuItem>
              <MenuItem value={1}>KOTAK MAHINDRA BANK</MenuItem>
              <MenuItem value={3}>DIGIO</MenuItem>
              <MenuItem value={2}>RAZORPAY REPAYMENTS</MenuItem>
              <MenuItem value={4}>RBL</MenuItem>
            </Select>
          </FormControl>
        </Box>  
          </Grid>
          </Grid>
          {(Number(reasonCode) === 5 || (Number(loanstate?.status) === 4 && Number(reasonCode) === 4)) && (
            <Grid container spacing={2} paddingLeft="10px" paddingRight="10px" paddingTop="10px">
              <Grid item xs={12}>
                <TextField
                  label="Notes"
                  variant="outlined"
                  multiline
                  rows={3}
                  fullWidth
                  value={activityNotes || ""}
                  onKeyDown={(e) => e.stopPropagation()} 
                  onChange={(e) => {
                    setActivityNotes(e.target.value);
                    if (e.target.value?.trim().length >= 50) {
                      setRemarksError(false);
                    }
                  }}
                  error={remarksError}
                  helperText={remarksError ? "Notes should be minimum 50 characters" : ""}
                />
              </Grid>
            </Grid>
          )}
          
          <Grid container spacing={2} paddingLeft="10px" paddingRight="10px" paddingTop="10px">
          <Grid item xs={6}>
          <Typography gutterBottom style={{fontFamily:'Inter-Medium',fontSize:'14px',marginBottom:'-3px',fontWeight:'500' }}>Paid Date</Typography>
          <Datetime
              id="fromDate"
              dateFormat="YYYY/MM/DD"
              timeFormat={false}
              onChange={(date) => setSelectedDate(moment.isMoment(date) ? date.format('YYYY/MM/DD') : null)}
              locale="en-gb"
              closeOnSelect={true}
              inputProps={{ placeholder: 'Paid Date',style:{fontFamily:'Inter-Medium',fontSize:'14px',height:'4em',borderColor:'#D3D3D3',borderRadius:'5px'} }}
            />          
          </Grid>
          <Grid item xs={6}>
            <Typography gutterBottom style={{fontFamily:'Inter-Medium',fontSize:'14px',marginBottom:'-3px',fontWeight:'500' }} >Transaction ID</Typography>
          <TextField placeholder='Transaction Id' variant="outlined" InputLabelProps={{style: { fontSize: '14px',border:'none' }}} style={{width:"100%"}} onChange={(e)=>setTransactionId(e.target.value)}/>
          </Grid>
          </Grid>
          <Grid container display="flex" justifyContent="center" paddingBottom="15px">
            <Grid item>
              <Button style={{backgroundColor:isFormInvalid ? '#cccccc' : '#D32028',marginTop:'2rem',color:'white',cursor: isFormInvalid ? 'not-allowed' : 'pointer'}} disabled={isFormInvalid} onClick={()=>generateReceipt()}>SUBMIT</Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </>
  );
}